import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { endTime: String, removeAfterEnd: { type: Boolean, default: true } }

  static secondsInMinute = 60
  static secondsInHour = 60 * this.secondsInMinute
  static secondsInDay = 24 * this.secondsInHour
  static secondsInYear = 365 * this.secondsInDay
  static divisors = {
    days: {
      modulo: this.secondsInYear,
      result: this.secondsInDay
    },
    hours: {
      modulo: this.secondsInDay,
      result: this.secondsInHour
    },
    minutes: {
      modulo: this.secondsInHour,
      result: this.secondsInMinute
    },
    seconds: {
      modulo: this.secondsInMinute,
      result: 1
    }
  }

  static milliSecondsInSecond = 1000

  connect() {
    this.endTime = new Date(this.endTimeValue)

    this.interval = setInterval(() => this.#tick(), this.constructor.milliSecondsInSecond)
    this.#tick()
    this.element.classList.remove(this.hiddenClass)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  #tick() {
    const remainingSeconds = this.#getRemainingSeconds(this.endTime)

    if (remainingSeconds < 0) {
      if (this.removeAfterEndValue) {
        this.element.remove()
      }
    } else {
      this.#refreshCountdown(remainingSeconds)
    }
  }

  #getRemainingSeconds(date) {
    return Math.floor((date - Date.now()) / this.constructor.milliSecondsInSecond)
  }

  #refreshCountdown(remainingSeconds) {
    Object.keys(this.constructor.divisors).forEach(unit => {
      const target = this.targets.find(unit)
      if (target) {
        target.innerHTML = this.#remainingInUnit(remainingSeconds, unit)
      }
    })
  }

  #remainingInUnit(remainingSeconds, unit) {
    const divisor = this.constructor.divisors[unit]
    const moduloResult = remainingSeconds % divisor.modulo

    return Math.floor(moduloResult / divisor.result)
  }
}
